import React, { useState, useEffect } from 'react';
import axios from '../../common/axios';
import { Card, Alert } from 'antd';
import CircularLoader from '../../common/CircularLoader';
import MathJaxHTMLContent from "../../common/MathJaxHTMLContent";

const QuestionActivities = ({ step }) => {
    const [isLoading, setLoading] = useState(true);
    const [questions, setQuestions] = useState();
    const [questionResultsMap, setQuestionResultsMap] = useState();
    const [error, setError] = useState();

    const loadQuestionResults = async () => {
        setLoading(true);
        try {
            const response = await axios.get('/web/ui/question/trail/question/results', {
                params: { pathwayUserId: step.pathwayUserId, stepId: step.stepId },
            });

            const resultMap = {};
            (response.data.questionResults || []).forEach(result => {
                resultMap[result.questionId] = result;
            });

            setQuestions(response.data.questions);
            setQuestionResultsMap(resultMap);
            setError(undefined);
        } catch (err) {
            console.error('Error loading question activities:', err);
            setError('Failed to load activity. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const insertQuestionAnswers = (questionResult, questionContent) => {
        if (!questionResult || !questionContent) return;
        if (typeof window.inlineQuestions?.insertAnswers !== 'function') return;

        const $questionContent = $(questionContent);
        window.inlineQuestions.insertAnswers($questionContent, questionResult, questionResult.feedback);
        $('input, textarea, select', $questionContent).prop('disabled', true);
    };

    useEffect(() => {
        if (!step) {
            setQuestions(undefined);
            setQuestionResultsMap(undefined);
            setLoading(false);
            return;
        }
        loadQuestionResults();
    }, [step]);

    if (error) return <Alert showIcon={true} message={error} type="error" role="alert" />;
    if (isLoading) return <CircularLoader />;
    if (!questions) return <Alert showIcon={true} message="Questions not found" type="error" role="alert" />;

    return (
        <section className="ch-trail-question-activities">
            {questions.map((question, index) => {
                const questionResult = questionResultsMap?.[question.questionId];

                return (
                    <Card
                        key={question.questionId}
                        style={{ marginBottom: 'var(--spacing-unit)'}}
                    >
                        <div>
                            <h3>Question {index + 1}</h3>
                            <MathJaxHTMLContent
                                html={question.formattedInstructions || ''}
                                data-question-id={question.questionId}
                                refCallBack={(questionContent) =>
                                    insertQuestionAnswers(questionResult, questionContent)
                                }
                            />
                        </div>
                    </Card>
                );
            })}
        </section>
    );
};

export default QuestionActivities;
